export default __webpack_public_path__ + "static/media/news3.ebccb084.png";